import Vue from 'vue'
import VueRouter from 'vue-router'
import layout from '@/layout/layout.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: layout,
    redirect: '/',
    children: [
      {
        path: '/',
        name: 'HomePage',
        component: () => import('@/views/Home/HomePage.vue'),
        meta: {
          title: '联创智云-大数据与人工智应用赋能者'
        }
      },
      {
        path: '/NewList',
        name: 'NewList',
        component: () => import('@/views/NewList.vue'),
        meta: {
          title: '新闻动态'
        }
      },
      {
        path: '/Aboutus',
        name: 'Aboutus',
        component: () => import('@/views/Abouts/AboutView.vue'),
        meta: {
          title: '关于我们'
        }
      },
      {
        path: '/ProjectList',
        name: 'ProjectList',
        component: () => import('@/views/ProjectList.vue'),
        meta: {
          title: '项目案例'
        }
      },
      {
        path: '/GetJob',
        name: 'GetJob',
        component: () => import('@/views/GetJob/GetJobView.vue'),
        meta: {
          title: '求职招聘'
        }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})
router.afterEach((to, from) => {
  Vue.nextTick(() => {
    const mainContainer = document.querySelector('#app')
    if (mainContainer) {
      mainContainer.scrollTo?.({ top: 0, left: 0, behavior: 'instant' }) ||
      (mainContainer.scrollTop = 0)
    }
  })
})
router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  next()
})
export default router
